export const DISCTANCE_FROM_TOP_TO_SCROLL = 500;
export const TIME_TO_WAIT_FOR_SCROLL_STOP_TO_SUBSCRIBE = 500;
export const MAX_THREAD_TITLE_LENGTH = 250;
export const GLOBAL_THREAD_ID_FOR_AI_PROGRAMME = "66180fcad2f99c2cf1a5c490";
export const THREAD_EVENTS_CATEGORY_ID = "6601a21efc7075b7b03ecef5";
export const AI_PROGRAMME_ID = "65defc01fad6091eefeab8ad";